import React, { Component } from "react";
import api from "../../api";
import { storageServices } from "../../services/storage";
import AdminLayout from "../../components/adminLayout";
import Loader from "../../components/Loader";
import { resp } from "../../services/responseHandler";
export default class GeneralBot extends Component {
  constructor(props) {
    super(props);
    const query = new URLSearchParams(this.props.location.search);
    const rec_biz_id = query.get("biz_id");
    const rec_bot_id = query.get("bot_id");

    this.state = {
      biz_id: rec_biz_id,
      bot_id: rec_bot_id,
      bot: {},
      intents: [],
      loading: true,
    };
  }

  componentDidMount() {
    this.getBot();
    this.getIntents();
  }
  async getIntents() {
    await api
      .getService(`/intents/${this.state.biz_id}/${this.state.bot_id}`)
      .then(
        (res) => {
          console.log("Response:", res);
          let data = res?.data?.data;
          this.setState({
            intents: data?.intents,
            loading: false,
          });
        },
        (error) => {
          console.log("error", error);
          this.setState({
            loading: false,
          });
        }
      );
  }
  async getBot() {
    await api.getService(`/bot/${this.state.biz_id}/${this.state.bot_id}`).then(
      (res) => {
        console.log("Bot Resp:", res);
        let data = res?.data?.data;
        this.setState({
          bot: data,
        });
      },
      (error) => {
        console.log("error", error);
      }
    );
  }

  changeBotStatus = async (status, index) => {
    this.state.channels[index].enabled = !status;
    this.setState({ channels: this.state.channels });
  };

  updateBotStatus = (status) =>{
    this.setState({loading: true});
    let query = {status:status}
    api.putService(`/activate_bot/${this.state.bot.biz_id}/${this.state.bot.id}`,query)
    .then(
      (res) => {
        console.log("Response:", res);
        resp.ResponseHandler(res);
        this.setState({loading: false});
      },
      (error) => {
        console.log("error", error);
        resp.ErrorHandler(error);
        this.setState({loading: false});
      }
    );
  }

  deleteBot = () =>{
    this.setState({loading: true});
    let query = {}
    api.deleteService(`/bot/${this.state.bot.biz_id}/${this.state.bot.id}`,query)
    .then(
      (res) => {
        console.log("Response:", res);
        this.setState({loading: false});
        resp.ResponseHandler(res,null);
        this.props.history.goBack()
      },
      (error) => {
        console.log("error", error);
        resp.ErrorHandler(error);
        this.setState({loading: false});
      }
    );
  }


  render() {
    return (
      <AdminLayout>
        {this.state.loading ? <Loader /> : ""}
        <div className="row mb-5">
          <div className="col my-auto">
            <div className="buttons float-left">
              <button
                className="btn text-dark"
                onClick={this.props.history.goBack}
              >
                <i class="fa fa-chevron-circle-left" aria-hidden="true"></i> Go
                back
              </button>
            </div>
          </div>
          <div className="col my-auto text-center mx-auto clearfix">
            <img
              src="https://cdn-icons-png.flaticon.com/512/3135/3135458.png"
              className="img-fluid img-bot"
            />
            <span className="text-primary">
              <b>General Bot</b>
            </span>
          </div>

          <div className="col my-auto text-center">
                  
          <button type="button" class="btn btn-outline-danger"  onClick={() => this.deleteBot()}>Delete Bot</button>

          </div>
        </div>
        <div className=" bg-secondary p-3 mb-5">
          <div class="accordion" id="accordionIntents">
            {this.state.intents.map((int, index) => (
              <div class="card">
                <div class="card-header" id={"heading" + int?.tag}>
                  <h2 class="text-primary mb-0">
                    <button
                      class="btn btn-link"
                      type="button"
                      data-toggle="collapse"
                      data-target={"#" + int?.tag}
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      <i class="fa fa-folder-o" aria-hidden="true"></i>{" "}
                      {int?.tag}
                    </button>
                  </h2>
                </div>

                <div
                  id={int.tag}
                  class="collapse"
                  aria-labelledby={"heading" + int?.tag}
                  data-parent="#accordionIntents"
                >
                  <div class="card-body">
                    <form>
                      <div class="form-group row">
                        <label class="col-sm-2 col-form-label text-muted">
                          Questions
                        </label>
                        <p class="col-form-label">
                          {int?.patterns.map((pat, index) => pat + ", ")}
                        </p>
                      </div>
                      <div class="form-group row">
                        <label class="col-sm-2 col-form-label text-muted">
                          Responses
                        </label>
                        <div class="col-form-label">
                          {int?.responses.map((res, index) => (
                            <p> {res} </p>
                          ))}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </AdminLayout>
    );
  }
}
